"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.Life = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors; // eslint-disable-next-line react/prop-types

var LifeSvg = function LifeSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    viewBox: "0 0 44 44",
    fill: colors.legacy[color] || color,
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M 10.5,15 C 9.7,15 9,14.3 9,13.5 9,12.7 9.7,12 10.5,12 c 0.8,0 1.5,0.7 1.5,1.5 0,0.8 -0.7,1.5 -1.5,1.5 z m 0,-5 C 8.6,10 7,11.6 7,13.5 7,15.4 8.6,17 10.5,17 12.4,17 14,15.4 14,13.5 14,11.6 12.4,10 10.5,10 Z M 35,13.5 C 35,14.3 34.4,15 33.5,15 33.1,15 32.7,14.9 32.4,14.6 32.2,14.4 32,14 32,13.5 32,12.7 32.7,12 33.5,12 c 0.4,0 0.8,0.2 1.1,0.4 0.3,0.2 0.4,0.7 0.4,1.1 z M 33.5,10 C 31.6,10 30,11.6 30,13.5 v 0.09961 c 0,0.9 0.399609,1.8 1.099609,2.5 0.7,0.6 1.500391,1 2.400391,1 h 0.09961 c 1.9,0 3.500391,-1.6 3.400391,-3.5 C 37,11.599609 35.4,10 33.5,10 Z M 31,18 v 2 h 4 c 0.6,0 1.100391,0.199609 1.400391,0.599609 C 36.700391,20.999609 37,21.4 37,22 v 7.300781 c 0,0.6 -0.199219,1.19961 -0.699219,1.59961 C 36.000781,31.200391 35.6,31.5 35,31.5 H 34 V 40 c 0,0.6 0.4,1 1,1 0.6,0 1,-0.5 1,-1 v -6.599609 c 0.7,-0.2 1.199219,-0.5 1.699219,-1 0.9,-0.8 1.300781,-1.89961 1.300781,-3.09961 V 22 C 39,20.9 38.600781,19.899219 37.800781,19.199219 37.100781,18.399219 36.1,18 35,18 Z M 9,18 C 7.9,18 6.8992187,18.399219 6.1992188,19.199219 5.3992188,19.899219 5,20.9 5,22 v 7.300781 c 0,1.1 0.3996094,2.098438 1.0996094,2.898438 0.5,0.6 1.2003906,1.001172 1.9003906,1.201172 V 40 c 0,0.6 0.4,1 1,1 0.6,0 1,-0.4 1,-1 V 31.5 H 9 C 8.5,31.5 7.9996094,31.300391 7.5996094,30.900391 7.1996094,30.500391 7,29.900781 7,29.300781 V 22 C 7,21.4 7.1996094,20.899609 7.5996094,20.599609 7.8996094,20.199609 8.4,20 9,20 h 4 V 18 Z M 19.099609,12 C 16.799609,12 15,13.899609 15,16.099609 v 10.5 c 0,2 1.3,3.701172 3,4.201172 v 9.09961 c 0,0.6 0.4,1 1,1 0.6,0 1,-0.4 1,-1 v -11 H 19 C 17.8,28.900391 17,27.7 17,26.5 V 16 c 0,-1.2 0.899609,-2.099609 2.099609,-2.099609 H 25 c 0.5,0 1.000391,0.199609 1.400391,0.599609 C 26.800391,14.9 27,15.499609 27,16.099609 V 27 c 0,0.6 -0.199609,1.100391 -0.599609,1.400391 C 26.100391,28.800391 25.6,29 25,29 h -1 v 11 c 0,0.6 0.4,1 1,1 0.6,0 1,-0.4 1,-1 V 30.900391 C 27.7,30.500391 29,28.9 29,27 V 16.199219 c 0,-1.1 -0.399609,-2.098438 -1.099609,-2.898438 C 27.200391,12.400781 26.1,12 25,12 Z M 22,3 c -2.2,0 -4,1.8 -4,4 0,2.2 1.8,4 4,4 2.2,0 4,-1.8 4,-4 0,-2.2 -1.8,-4 -4,-4 z"
  }));
};

var Life = (0, _styledComponents.default)(LifeSvg).withConfig({
  displayName: "Life",
  componentId: "sc-z2srda-0"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
exports.Life = Life;
Life.defaultProps = {
  color: "" + colors.brand.snswSecondaryBlue,
  height: 44,
  width: 44
};
var _default = Life;
exports.default = _default;